import { API_URL, getCachedSessionId } from 'src/services/common';
import { api } from '../../../../util/axios-instance';

export const createUser = async (id, data) => {
  await api.post(`${API_URL}/v1/project/${id}/user`, data, {
    headers: { 'x-session-id': getCachedSessionId() }
  });
};
